export const darkAnalyticFills = [
  "#5F3113", // deep orange-brown (base)
  "#264653", // deep teal
  "#2A9D8F", // turquoise
  "#1D3557", // navy blue
  "#457B9D", // steel blue
  "#8D99AE", // cool gray-blue
  "#6A994E", // olive green
  "#386641", // forest green
  "#A3B18A", // muted sage
  "#7B2CBF", // rich purple
  "#5E60CE", // indigo
  "#9D4EDD", // violet
  "#C77DFF", // lavender accent
  "#B56576", // muted rose
  "#E56B6F", // coral red
  "#D62828", // strong crimson
  "#F77F00", // amber (but not orange-brown like base)
  "#F9C74F", // golden yellow
  "#90BE6D", // light green
  "#43AA8B", // sea green
];

export const lightAnalyticFills = [
  "#A97456", // lighter orange-brown (base)
  "#4F7A85", // lighter deep teal
  "#58B6A7", // softer turquoise
  "#5C6F8A", // muted navy
  "#7FA1B7", // light steel blue
  "#B0B8C5", // soft gray-blue
  "#8CB377", // softer olive
  "#5D8C63", // soft forest green
  "#C3D2B8", // pale sage
  "#9B6DCB", // lighter purple
  "#7E82DA", // soft indigo
  "#B889E6", // light violet
  "#D3A6F7", // lavender pastel
  "#D4979F", // soft muted rose
  "#F1999B", // soft coral red
  "#E57C7E", // muted crimson
  "#FBAF4B", // light amber
  "#FDDC90", // soft golden yellow
  "#B5D49E", // light green
  "#7CCFB8", // minty sea green
];
